import React from 'react'
import CourseSelectInput from './CourseSelectInput'
import TopicSelectInput from './TopicSelectInput'

function CourseTopicSelector({ register, errors, watch }) {
  return (
    <div className="flex gap-3 max-w-3xl mb-4">
      <CourseSelectInput
        name="course_id"
        register={register}
        errors={errors}
        validationRules = {{ required: false }}
      />
      <TopicSelectInput
        name="topic_id"
        register={register}
        errors={errors}
        course_filter_id={watch('course_id')}
      />
    </div>
  )
}

export default CourseTopicSelector
